import React from 'react';
import CustomerAttentionCard from './CustomerAttentionCard';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

interface Customer {
  Name?: string;
  Reason?: string;
}

interface CustomersNeedingAttentionSectionProps {
  customers: (Customer | string)[];
}

const CustomersNeedingAttentionSection: React.FC<CustomersNeedingAttentionSectionProps> = ({ customers }) => {
  if (!customers || customers.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      //marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #ed8936',
      breakInside: 'avoid'
    }}>
      <h2 style={{ color: '#ed8936', marginBottom: '1rem', fontSize: '1.5rem', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
        <NotificationsActiveIcon style={{ marginRight: '8px' }} />
        Customers Needing Attention
      </h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {customers.map((customer, index) => (
          <CustomerAttentionCard key={index} customer={customer} />
        ))}
      </ul>
    </div>
  );
};

export default CustomersNeedingAttentionSection;
